import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SEOHead from '@/components/SEOHead';

export default function TermsConditions() {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead 
        title={t('legal.terms.title')} 
        description={t('legal.terms.metaDescription')}
        path="/terms-conditions"
      />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <Link to="/">
            <Button variant="ghost" className="mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {t('common.back')}
            </Button>
          </Link>

          <h1 className="text-3xl font-bold text-foreground mb-6">{t('legal.terms.title')}</h1>
          <p className="text-sm text-muted-foreground mb-8">{t('legal.terms.lastUpdated')}: 02/01/2026</p>

          <div className="prose prose-sm dark:prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.acceptance.title')}</h2>
              <p className="text-muted-foreground">{t('legal.terms.sections.acceptance.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.service.title')}</h2>
              <p className="text-muted-foreground">{t('legal.terms.sections.service.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.account.title')}</h2>
              <p className="text-muted-foreground">{t('legal.terms.sections.account.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.payment.title')}</h2>
              <p className="text-muted-foreground">{t('legal.terms.sections.payment.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.intellectualProperty.title')}</h2>
              <p className="text-muted-foreground">{t('legal.terms.sections.intellectualProperty.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.liability.title')}</h2>
              <p className="text-muted-foreground">{t('legal.terms.sections.liability.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.termination.title')}</h2>
              <p className="text-muted-foreground">{t('legal.terms.sections.termination.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.governing.title')}</h2>
              <p className="text-muted-foreground">{t('legal.terms.sections.governing.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.terms.sections.contact.title')}</h2>
              <p className="text-muted-foreground">
                {t('legal.terms.sections.contact.content')}{' '}
                <a href="mailto:support@tedmonitor.eu" className="text-primary hover:underline">
                  support@tedmonitor.eu
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
